import { TemplateRef, ViewContainerRef } from '@angular/core';
import * as i0 from "@angular/core";
export class NgLetContext {
  constructor() {
    this.$implicit = null;
    this.ngLet = null;
  }
}
// example: <ng-template [ngLet]="isAdmin$|async" let-isAdmin>
export let NgLetDirective = /*#__PURE__*/(() => {
  class NgLetDirective {
    set ngLet(value) {
      this._context.$implicit = this._context.ngLet = value;
    }
    constructor(_vcr, _templateRef) {
      this._vcr = _vcr;
      this._templateRef = _templateRef;
      this._context = new NgLetContext();
    }
    ngOnInit() {
      this._vcr.createEmbeddedView(this._templateRef, this._context);
    }
    static {
      this.ɵfac = function NgLetDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgLetDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: NgLetDirective,
        selectors: [["", "ngLet", ""]],
        inputs: {
          ngLet: "ngLet"
        }
      });
    }
  }
  return NgLetDirective;
})();